export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_IS_LOADING_USER = 'SET_IS_LOADING_USER';